import React from "react";
import { SPopupContext } from "App/common/hoc/SlidingPopup";
import { useHotKeys } from "./../../../../../common/hooks/hotKeys";
import { EDIT_BACKUP_PLAN_SETTINGS } from "App/componentsConfig";
import Tooltip from "App/common/ui/Tooltip";
import { TOOLTIPS } from "consts";
import { ReactComponent as InformationIcon } from "assets/images/app_svg/information.svg";
import BackupPlanFooter from "./../Footer";
import { deepClone } from "utils";

function EditPlanSettings(props) {
  const panel = EDIT_BACKUP_PLAN_SETTINGS[props.currentPanel.type];
  const { sPopupState } = React.useContext(SPopupContext);
  const [planSettings, setPlanSettings] = React.useState({
    ...props.currentPanel.params.planSettings
  });
  const [defaultSave, setDefaultSave] = React.useState(false);
  const [originalSettings, setOriginalSettings] = React.useState(
    deepClone({ ...props.currentPanel.params.planSettings })
  );
  useHotKeys(
    "backspace",
    e => {
      e.preventDefault();
      switchPanel();
    },
    [sPopupState]
  );

  function switchPanel(dontShowSaveDiscard) {
    if (!sPopupState.disableClose.close) {
      if (dontShowSaveDiscard) {
        if (
          sPopupState.disableClose.params.display("backToSummaryDefaultSave")
        ) {
          props.switchPanel("summary");
        }
      } else {
        if (sPopupState.disableClose.params.display("backToSummary")) {
          props.switchPanel("summary");
        }
      }
    } else props.switchPanel("summary");
  }

  function switchPanelWithSave() {
    //setDefaultSave(true)
    switchPanel(true);
  }

  return (
    <div className={panel.class} style={{ display: "block" }}>
      <div className="slider_content is_relative">
        <div className="create_plan_head">
          <div
            className="back_btn"
            title="Back"
            onClick={() => switchPanelWithSave()}
          ></div>
          <h2>
            <span>{panel.title}</span>
            {panel.toolTip && (
              <Tooltip {...panel.toolTip}>
                <span className="icon">
                  <InformationIcon />
                </span>
              </Tooltip>
            )}
          </h2>
        </div>
        {React.createElement(panel.component, {
          planSettings: planSettings,
          isSummary: false,
          setPlanSettings: setPlanSettings,
          switchPanel: props.switchPanel
        })}
        <BackupPlanFooter
          {...{
            planSettings: planSettings,
            isSummary: false,
            setPlanSettings: setPlanSettings,
            switchPanel: props.switchPanel,
            originalSettings: originalSettings,
            setOriginalSettings: setOriginalSettings,
            defaultSave: defaultSave,
            setDefaultSave: setDefaultSave
          }}
        />
      </div>
    </div>
  );
}

export default EditPlanSettings;
